import { requestApiJson } from '../../shared/api/client'

const toErrorMessage = (status: number, payload: unknown) => {
  if (payload && typeof payload === 'object') {
    const message = (payload as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) {
      return message.trim()
    }
  }

  if (status === 400) return 'Dati non validi'
  if (status === 401) return 'Credenziali non valide o sessione scaduta'
  if (status === 403) return 'Account non autorizzato per area cliente'
  if (status === 409) return 'Email gia registrata'
  if (status === 503) return 'Servizio temporaneamente non disponibile'
  if (status === 504) return 'Il servizio sta impiegando troppo tempo. Riprova.'
  return 'Non siamo riusciti a creare l account. Riprova tra qualche secondo.'
}

export class CustomerAuthApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export const requestCustomerAuthJson = <T>(path: string, init?: RequestInit): Promise<T> =>
  requestApiJson<T>({
    path,
    init,
    toErrorMessage,
    createError: (status, message) => new CustomerAuthApiError(status, message),
  })
